/* eslint-disable no-redeclare, import/order */
import ENVIRONMENTS from './enviroments';

// Component Password
import RESET_PASSWORD from 'assets/images/componentPassword/reset-password.png';
import IVITE_MESSAGE_PASSWORD from 'assets/images/componentPassword/Invite-mensagem-senha.png';
import CELEBRATION_PANA_SUCCES from 'assets/images/componentPassword/celebration-pana-succes.png';

// Color Picker Component
import COLOR_PICKER_IMAGE from 'assets/images/colorpickermap.gif';
import ASTRONAUT from 'assets/images/astronaut.gif';

// Icons
import MAN_NO_CHECKED_ICON from 'assets/images/icons/manNoCheckedIcon.svg';
import MAN_CHECKED_ICON from 'assets/images/icons/manCheckedIcon.svg';
import BUS_FRONT_NO_CHECKED_ICON from 'assets/images/icons/busFrontNoCheckedIcon.svg';
import BUS_FRONT_CHECKED_ICON from 'assets/images/icons/busFrontCheckedIcon.svg';
import APROVE_ICON from 'assets/images/icons/aprove.svg';
import REPROVE_ICON from 'assets/images/icons/reprove.svg';
import IMPRECISION_ICON from 'assets/images/icons/imprecision.svg';
import BACK_BUTTON_ICON from 'assets/images/icons/back_button.png';
import NEXT_BUTTON_ICON from 'assets/images/icons/next_button.png';
import REPROVE_LARGE_ICON from 'assets/images/icons/reprove_large.png';
import CAMERA_ICON from 'assets/images/icons/poorly_positioned_camera.svg';
import IMAGE_OBSTRUCTION_ICON from 'assets/images/icons/image_obstruction.svg';
import SLOW_RESOLUTION_ICON from 'assets/images/icons/slow_resolution.svg';
import LOW_LIGHT_ICON from 'assets/images/icons/low_light.svg';
import EXCESS_BRIGHTNESS_ICON from 'assets/images/icons/excess_brightness.svg';
import ANOTHER_MOTIVE_ICON from 'assets/images/icons/another_motive.svg';
import DOWNLOAD_ICON from 'assets/images/icons/download.svg';
import EYE_ON_ICON from 'assets/images/icons/eyeOn.svg';
import EYE_OFF_ICON from 'assets/images/icons/eyeOff.svg';
import PHONE_ICON from 'assets/images/icons/phone.svg';
import CARD_ICON from 'assets/images/icons/creditCard.svg';
import DEBIT_CARD_ICON from 'assets/images/icons/DEBIT_CARD.svg';
import SMARTWATCH_ICON from 'assets/images/icons/smartWatch.svg';
import CHECK_ICON from 'assets/images/icons/check.svg';
import CHECK_OUTLINE_ICON from 'assets/images/icons/check_outline.svg';
import UNCHECKED_ICON from 'assets/images/icons/uncheckd.svg';
import BLOCK_ICON from 'assets/images/icons/block.svg';
import SAVE_ICON from 'assets/images/icons/save.svg';
import EDIT_ICON from 'assets/images/icons/edit.svg';
import DELETE_ICON from 'assets/images/icons/delete.svg';
import UPDATE_ICON from 'assets/images/icons/update.svg';
import CLOSE_ICON from 'assets/images/icons/close.svg';
import ADD_ICON from 'assets/images/icons/add.svg';
import ARROW_FORWARD_ICON from 'assets/images/icons/arrow_forward.svg';
import ARROW_BACK_ICON from 'assets/images/icons/arrow_back.svg';
import MORE_HORIZ_ICON from 'assets/images/icons/more_horiz.svg';
import ICON_WHITE_PENCIL from 'assets/images/icons/white-pencil.png';
import ICON_BLACK_PENCIL from 'assets/images/blackPencilIcon.svg';
import BALLON_ICON from 'assets/images/icons/ballon.svg';
import BALLON_HIGH_ICON from 'assets/images/icons/ballon_high.png';
import BALLON_MEDIUM_ICON from 'assets/images/icons/ballon_medium.png';
import BALLON_SLOW_ICON from 'assets/images/icons/ballon_slow.png';
import DESTROY_ICON from 'assets/images/icons/destroy.svg';
import FAILURE_ICON from 'assets/images/icons/failure.svg';
import CHART_ICON from 'assets/images/icons/chart.svg';
import NON_STANDARD_ICON from 'assets/images/icons/nonstandard_image.svg';
import INVALID_DOCUMENT_ICON from 'assets/images/icons/invalid_document.svg';
import INCOMPATIBLE_PHOTO_ICON from 'assets/images/icons/incompatible_photo.svg';
import NOTATION_ICON from 'assets/images/icons/notation.svg';
import CALENDAR_ICON from 'assets/images/icons/calendar.svg';
import CALENDAR_ICON_BLACK from 'assets/images/icons/calendarIconBlack.svg';
import CALENDAR_ICON_BLUE from 'assets/images/icons/calendarIcon.svg';
import HISTORY_ICON_BLUE from 'assets/images/icons/historyIcon.svg';
import PROGRAMMING_ICON_BLUE from 'assets/images/icons/programmingIcon.svg';
import CALENDAR_OUTLINE_ICON from 'assets/images/icons/calendar_outline.svg';
import HISTORY_ICON from 'assets/images/icons/history.svg';
import XLSX_ICON from 'assets/images/icons/xlsx.svg';
import NO_IMAGE_ICON from 'assets/images/icons/noImage.svg';
import CSV_ICON from 'assets/images/icons/csv.svg';
import CSV2_ICON from 'assets/images/icons/csv2.svg';
import PDF_ICON from 'assets/images/icons/pdf.svg';
import EMPLOYEE_ICON from 'assets/images/icons/employee.svg';
import CAR_ICON from 'assets/images/icons/car.svg';
import ATTACHMENT_ICON from 'assets/images/icons/attachment.svg';
import OPEN_EYES from 'assets/images/icons/open_eyes.png';
import CLOSE_EYES from 'assets/images/icons/close_eyes.png';
import BUS_ICON from 'assets/images/icons/bus.svg';
import LINE_ICON from 'assets/images/icons/line.svg';
import STOP_ICON from 'assets/images/icons/stop.svg';
import CART_ICON from 'assets/images/icons/cart.svg';
import WATCH_ICON from 'assets/images/icons/watch.svg';
import EMAIL_ICON from 'assets/images/icons/e-mail.svg';
import FILTORS_BUTTON from 'assets/images/icons/filtorsButton.svg';
import SAVE_COMPANY_ICON from 'assets/images/icons/saveCompany.svg';
import CLOSE_COMPANY_ICON from 'assets/images/icons/closeCompany.svg';
import EDIT_COMPANY_ICON from 'assets/images/icons/editCompany.svg';
import DELETE_COMPANY_ICON from 'assets/images/icons/deleteCompany.svg';
import CAMERA_COMPANY_ICON from 'assets/images/icons/cameraIconCompany.svg';
import SEND_ICON from 'assets/images/icons/sendButton.svg';
import PAINT_ICON from 'assets/images/icons/paintIcon.svg';
import SEND_DISABLED_ICON from 'assets/images/icons/sendButtonDisabled.svg';
import CHANGED_ROW_ICON from 'assets/images/icons/changedIcon.svg';
import INFO_ICON from 'assets/images/icons/infoIcon.svg';
import UPDATE_DENYLIST from 'assets/images/icons/updateDenylist.svg';
import DBD_ICON from 'assets/images/icons/dbd.svg';
import GROUPINGS from 'assets/images/icons/groupings.svg';
import MERGE_ACCOUNTS_ICON from 'assets/images/icons/mergeAccountsIcon.svg';
import MERGE_ACCOUNTS_ICON_BLACK from 'assets/images/icons/mergeAccountsIconBlack.svg';
import MERGE_ACCOUNTS_WARNING_ICON from 'assets/images/icons/mergeAccountsWarningIcon.svg';
import MERGE_ACCOUNTS_FIRST_CARD_ICON from 'assets/images/icons/mergeAccountsFirstCardIcon.svg';
import MERGE_ACCOUNTS_SECOND_CARD_ICON from 'assets/images/icons/mergeAccountsSecondCardIcon.svg';
import MERGE_ACCOUNTS_SECOND_CARD_PLACEHOLDER from 'assets/images/placeholders/mergeAccountsCardPlaceholder.svg';
import MERGE_ACCOUNTS_SUCCESS_PLACEHOLDER from 'assets/images/placeholders/mergeAccountsSuccessPlaceholder.svg';
import MERGE_ACCOUNTS_ERROR_PLACEHOLDER from 'assets/images/placeholders/mergeAccountsErrorPlaceholder.svg';
import CONFLICT_SCHEDULES_IMAGE_PLACEHOLDER from 'assets/images/placeholders/CONFLICT_SCHEDULES_IMAGE.svg';
import FILE from 'assets/images/icons/file.svg';
import ALERT from 'assets/images/icons/alert.svg';
import REPLY_TABLE_ICON from 'assets/images/icons/replyTableIcon.svg';
import REPLY_TABLE_ICON_DISABLED from 'assets/images/icons/replyTableIconDisabled.svg';
import PIX_ICON from 'assets/images/icons/pixIcon.svg';
import PIX_ICON_BLUE from 'assets/images/icons/pixIconBlue.svg';
import BOLETO_ICON from 'assets/images/icons/boletoIcon.svg';
import BOLETO_ICON_BLUE from 'assets/images/icons/boletoIconBlue.svg';
import PRINTER_ICON from 'assets/images/icons/printerIcon.svg';
import ANOTATIONS from 'assets/images/icons/anotations.svg';
import CURRENCY from 'assets/images/icons/currency.svg';
import ONBOARD_LOGO_ICON from 'assets/images/icons/logoOnboardBlack.svg';
import CHECK_ICON_BLUE from 'assets/images/icons/checkIconBlue.svg';
import TERMINAL_ICON_01_ICON from 'assets/images/icons/TERMINAL_ICON_01.svg';
import TERMINAL_ICON_02_ICON from 'assets/images/icons/TERMINAL_ICON_02.svg';
import TERMINAL_ICON_03_ICON from 'assets/images/icons/TERMINAL_ICON_03.svg';
import TERMINAL_ICON_04_ICON from 'assets/images/icons/TERMINAL_ICON_04.svg';
import TERMINAL_ICON_05_ICON from 'assets/images/icons/TERMINAL_ICON_05.svg';
import TERMINAL_ICON_06_ICON from 'assets/images/icons/TERMINAL_ICON_06.svg';
import TERMINAL_ICON_07_ICON from 'assets/images/icons/TERMINAL_ICON_07.svg';
import TERMINAL_ICON_08_ICON from 'assets/images/icons/TERMINAL_ICON_08.svg';
import TERMINAL_ICON_09_ICON from 'assets/images/icons/TERMINAL_ICON_09.svg';
import TERMINAL_ICON_10_ICON from 'assets/images/icons/TERMINAL_ICON_10.svg';
import TERMINAL_ICON_11_ICON from 'assets/images/icons/TERMINAL_ICON_11.svg';
import TERMINAL_ICON_12_ICON from 'assets/images/icons/TERMINAL_ICON_12.svg';
import TERMINAL_ICON_13_ICON from 'assets/images/icons/TERMINAL_ICON_13.svg';
import TERMINAL_ICON_14_ICON from 'assets/images/icons/TERMINAL_ICON_14.svg';
import LOCK_IDLE_ICON from 'assets/images/icons/LOCK_IDLE.svg';
import EDIT_BLACK_ICON from 'assets/images/icons/EDIT_BLACK.svg';
import ROTATE_BLACK_ICON from 'assets/images/icons/ROTATE_BLACK.svg';
import DELETE_BLACK_ICON from 'assets/images/icons/DELETE_BLACK.svg';
import ENTRY_BLOCK_ICON from 'assets/images/icons/ENTRY_BLOCK.svg';
import BLOCK_HAS_ALERT_ICON from 'assets/images/icons/BLOCK_HAS_ALERT.svg';
import EXIT_BLOCK_ICON from 'assets/images/icons/EXIT_BLOCK.svg';
import FREE_BLOCK_ICON from 'assets/images/icons/FREE_BLOCK.svg';
import LOCKED_BLOCK_ICON from 'assets/images/icons/LOCKED_BLOCK.svg';
import ACTIVITY_LOG_ICON from 'assets/images/icons/ACTIVITY_LOG.svg';
import TRANSACTIONS_RESUME_ICON from 'assets/images/icons/TRANSACTIONS_RESUME.svg';
import UPDATE_STATUS_BUTTON_ICON from 'assets/images/icons/UPDATE_STATUS_BUTTON.svg';
import RELEASE_BLOCKS_ICON from 'assets/images/icons/RELEASE_BLOCKS_ICON.svg';
import RESET_BLOCKS_ICON from 'assets/images/icons/RESET_BLOCKS_ICON.svg';
import RELEASE_BLOCKS_GREEN_ICON from 'assets/images/icons/RELEASE_BLOCKS_ICON_GREEN.svg';
import RELEASE_BLOCKS_ORANGE_ICON from 'assets/images/icons/RELEASE_BLOCKS_ICON_ORANGE.svg';
import NFE_ICON from 'assets/images/icons/nfeIcon.svg';
import LINK_ICON from 'assets/images/icons/VINCULAR.svg';
import INFO_ICON_2 from 'assets/images/icons/INFO_ICON.svg';
import CLOCK_ICON_2 from 'assets/images/icons/CLOCK_ICON.svg';
import PASSENGERS_BY_TERMINAL_ICON from 'assets/images/icons/PASSENGERS_BY_TERMINAL.svg';
import VOUCHER_SRC_ICON from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Voucher.svg';
import IP_ADDRESS_ICON from 'assets/images/icons/IpAddressIcon.svg';
import MONEY_SRC_ICON from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Dinheiro.svg';
import DETAILS_ICON from 'assets/images/icons/details.svg';

// Report Icons
import TOTAL_ENTRY from 'assets/images/icons/reports_icons/totalEntry.svg';
import QUANTITY_ENTRY from 'assets/images/icons/reports_icons/quantityEntry.svg';
import DOWNLOAD from 'assets/images/icons/reports_icons/download.svg';
import TICKET_SOLD from 'assets/images/icons/reports_icons/ticketSold.svg';
import CREDIT_PORTFOLIO from 'assets/images/icons/reports_icons/creditPortfolio.svg';
import PDF from 'assets/images/icons/reports_icons/pdf.svg';
import PDF_CHECKED from 'assets/images/icons/reports_icons/pdfChecked.svg';
import CSV from 'assets/images/icons/reports_icons/csv.svg';
import CSV_CHECKED from 'assets/images/icons/reports_icons/csvChecked.svg';
import XLS from 'assets/images/icons/reports_icons/xls.svg';
import XLS_CHECKED from 'assets/images/icons/reports_icons/xlsChecked.svg';
import FILTERS from 'assets/images/icons/reports_icons/filtersButton.svg';
import FILTERS_BLACK from 'assets/images/icons/reports_icons/filtersButtonBlack.svg';
import AGRUPMENTS from 'assets/images/icons/reports_icons/agrupments.svg';
import AGRUPMENTS_BLACK from 'assets/images/icons/reports_icons/agrupmentsBlack.svg';
import OPEN_REPORTS from 'assets/images/icons/reports_icons/openReports.svg';
import SEND_MENSSAGE from 'assets/images/icons/reports_icons/sendMessage.svg';

// Map Icons
import WIFI_ACTIVED from 'assets/images/icons/map_icons/wifiActived.svg';
import PURCHASE_ACTIVED from 'assets/images/icons/map_icons/purchaseActived.svg';
import LINE_ACTIVED from 'assets/images/icons/map_icons/lineActived.svg';
import POINT_ACTIVED from 'assets/images/icons/map_icons/pointActived.svg';
import WIFI from 'assets/images/icons/map_icons/wifi.svg';
import PURCHASE from 'assets/images/icons/map_icons/purchase.svg';
import BOARDING from 'assets/images/icons/map_icons/boarding.svg';
import LANDING from 'assets/images/icons/map_icons/landing.svg';
import GO_ARROW from 'assets/images/icons/map_icons/goArrow.svg';
import BACK_ARROW from 'assets/images/icons/map_icons/backArrow.svg';
import BOARDING_ACTIVED from 'assets/images/icons/map_icons/boardingActive.svg';
import LANDING_ACTIVED from 'assets/images/icons/map_icons/landingActive.svg';
import GO_ARROW_ACTIVED from 'assets/images/icons/map_icons/goArrowActive.svg';
import BACK_ARROW_ACTIVED from 'assets/images/icons/map_icons/backArrowActive.svg';
import LINE from 'assets/images/icons/map_icons/line.svg';
import POINT from 'assets/images/icons/map_icons/point.svg';
import POLYGON_AGROUP from 'assets/images/icons/map_icons/polygonAgroup.svg';
import VIVO from 'assets/images/icons/map_icons/vivo.svg';
import CLARO from 'assets/images/icons/map_icons/claro.svg';
import TIM from 'assets/images/icons/map_icons/tim.svg';
import OI from 'assets/images/icons/map_icons/oi.svg';
import IMAGE_ICON from 'assets/images/icons/iconImage.svg';
import DOWN_ARROW from 'assets/images/icons/downArrow.svg';
import UP_ARROW from 'assets/images/icons/upArrow.svg';
import OK from 'assets/images/icons/ok.svg';
import MINI_CAMERA_ICON from 'assets/images/icons/mini_camera.svg';
import LARGE_TRASH_ICON from 'assets/images/icons/large_trash.svg';
import CLOCK_ICON from 'assets/images/icons/clock.svg';
import UPLOAD_ICON from 'assets/images/icons/upload.svg';
import OPEN_DOT_ICON from 'assets/images/icons/openDot.svg';
import CLOSE_DOT_ICON from 'assets/images/icons/closeDot.svg';
import DOCUMENT_ICON from 'assets/images/addDocumentIcon.svg';
import BOOK_ICON from 'assets/images/bookIcon.svg';
import APPROVE_PROFILE_ICON from 'assets/images/approveIcon.svg';
import APPROVE_PROFILE_ICON_FLAT from 'assets/images/approveIconFlat.svg';
import BLOCK_PROFILE_ICON from 'assets/images/blockIcon.svg';
import BLOCK_PROFILE_ICON_FLAT from 'assets/images/blockIconFlat.svg';
import SHOPPING_CART_ICON from 'assets/images/icons/shoppingCart.svg';
import SHOPPING_CART_ICON_BLUE from 'assets/images/icons/shoppingCartBlue.svg';
import SEND_FILE_ICON from 'assets/images/icons/sendFileIcon.svg';
import PENDING_ICON from 'assets/images/icons/pendingIcon.svg';
import FINISHED_ICON from 'assets/images/icons/finishedIcon.svg';
import FAILED_ICON from 'assets/images/icons/failedIcon.svg';
import LIKE from 'assets/images/icons/like.svg';
import TRIP_REPORT_ICON from 'assets/images/icons/tripReportIcon.svg';
import LOGO_ONBOARD_MOBILITY_SMALL_WHITE from 'assets/images/icons/LOGO_ONBOARD_MOBILITY_SMALL_WHITE.svg';
import TERMINAL_ICON_BLACK from 'assets/images/icons/TERMINAL_ICON_BLACK.svg';
import NOT_TERMINAL_ICON_BLACK from 'assets/images/icons/NOT_TERMINAL_ICON_BLACK.svg';

// Drawer Icons
import PERSON_ICON from 'assets/images/drawerIcons/person.svg';
import ATTENDANCE_ICON from 'assets/images/drawerIcons/attendance.svg';
import ATTENDANCE_CHATBOT_ICON from 'assets/images/placeholders/attendance_chatbot.png';
import PLANNING_ICON from 'assets/images/drawerIcons/planning.png';
import TABLE_ICON from 'assets/images/drawerIcons/table.svg';
import PLANNING2_ICON from 'assets/images/drawerIcons/planning2.svg';
import FLEET_ICON from 'assets/images/drawerIcons/fleet.svg';
import OPERATION_ICON from 'assets/images/drawerIcons/operation.svg';
import FARES_ICON from 'assets/images/drawerIcons/fares.png';
import TICKETING_ICON from 'assets/images/drawerIcons/ticketing.svg';
import BIOMETRY_ICON from 'assets/images/drawerIcons/biometry.png';
import ADJUSTMENT_ICON from 'assets/images/drawerIcons/adjustment.png';
import FINANCIAL_ICON from 'assets/images/drawerIcons/financial.png';
import REPORTS_ICON from 'assets/images/drawerIcons/reports.svg';
import COLLECTION_ICON from 'assets/images/drawerIcons/collection.svg';
import MONITORING_ICON from 'assets/images/drawerIcons/monitoring.svg';
import INTEGRITY_CENTER_ICON from 'assets/images/drawerIcons/integrityCenter.svg';
import TEAM_ICON from 'assets/images/drawerIcons/team.svg';
import CONECTIVITY_ICON from 'assets/images/drawerIcons/conectivity.svg';
import CHECK_CIRCLE_OUTLINE_ICON from 'assets/images/drawerIcons/check_circle_outline.svg';
import SALES_NETWORK from 'assets/images/drawerIcons/sales-network.svg';
import COMPANY_BENEFITS from 'assets/images/drawerIcons/shoppingCar.svg';
import COMPANY_COLLABORATORS from 'assets/images/drawerIcons/collaborators.svg';

// Modules Icons
import LUPA from 'assets/images/icons/Lupa.png';

// Modules Icons Black
import ATTENDANCE_BLACK from 'assets/images/modulesIconsBlack/Atendimento (Real Size).svg';
import CLIENTS_BLACK from 'assets/images/modulesIconsBlack/Clientes (Real Size).svg';
import VALIDATIONS_BLACK from 'assets/images/modulesIconsBlack/Validações (Real Size).svg';
import RELATIONSHIP_BLACK from 'assets/images/modulesIconsBlack/Relacionamentos (Real Size).svg';
import FLEET_BLACK from 'assets/images/modulesIconsBlack/Frota (Real Size).svg';
import TEAM_BLACK from 'assets/images/modulesIconsBlack/Equipe (Real Size).svg';
import TICKETING_BLACK from 'assets/images/modulesIconsBlack/Bilhetagem Real Size.svg';
import OPERATION_BLACK from 'assets/images/modulesIconsBlack/Operação (Real Size).svg';
import SCHEDULE_BLACK from 'assets/images/modulesIconsBlack/Programação (Real Size).svg';
import OCCURRENCES_BLACK from 'assets/images/modulesIconsBlack/Ocorrências (Real Size).svg';
import MONITORING_BLACK from 'assets/images/modulesIconsBlack/Monitoramento (Real Size).svg';
import COLLECTION_BLACK from 'assets/images/modulesIconsBlack/Arrecadação (Real Size).svg';
import ANALYTICS_BLACK from 'assets/images/modulesIconsBlack/Analytics (Real Size).svg';
import REPORTS_BLACK from 'assets/images/modulesIconsBlack/Relatorios (Real Size).svg';
import SETTINGS_BLACK from 'assets/images/modulesIconsBlack/Ajustes (Real Size).svg';
import INVOICES_BLACK from 'assets/images/modulesIconsBlack/Faturas (Real Size).svg';
import MANAGEMENT_BLACK from 'assets/images/modulesIconsBlack/Gerenciar Empresa (Real Size).svg';
import CONECTIVITY_BLACK from 'assets/images/modulesIconsBlack/Conectividade (Real Size).svg';

// Modules Icons White
import ATTENDANCE_WHITE from 'assets/images/modulesIconsWite/Atendimento (Real Size).svg';
import CLIENTS_WHITE from 'assets/images/modulesIconsWite/Clientes (Real Size).svg';
import VALIDATIONS_WHITE from 'assets/images/modulesIconsWite/Validações (Real Size).svg';
import RELATIONSHIP_WHITE from 'assets/images/modulesIconsWite/Relacionamentos (Real Size).svg';
import FLEET_WHITE from 'assets/images/modulesIconsWite/Frota (Real Size).svg';
import TEAM_WHITE from 'assets/images/modulesIconsWite/Equipe (Real Size).svg';
import TICKETING_WHITE from 'assets/images/modulesIconsWite/Bilhetagem Real Size.svg';
import OPERATION_WHITE from 'assets/images/modulesIconsWite/Operação (Real Size).svg';
import SCHEDULE_WHITE from 'assets/images/modulesIconsWite/Programação (Real Size).svg';
import OCCURRENCES_WHITE from 'assets/images/modulesIconsWite/Ocorrências (Real Size).svg';
import MONITORING_WHITE from 'assets/images/modulesIconsWite/Monitoramento (Real Size).svg';
import COLLECTION_WHITE from 'assets/images/modulesIconsWite/Arrecadação (Real Size).svg';
import ANALYTICS_WHITE from 'assets/images/modulesIconsWite/Analytics (Real Size).svg';
import REPORTS_WHITE from 'assets/images/modulesIconsWite/Relatorios (Real Size).svg';
import SETTINGS_WHITE from 'assets/images/modulesIconsWite/Ajustes (Real Size).svg';
import INVOICES_WHITE from 'assets/images/modulesIconsWite/Faturas (Real Size).svg';
import CONECTIVITY_WHITE from 'assets/images/modulesIconsWite/Conectividade (Real Size).svg';

// Facial Recognition
import NO_IMAGE_INSPECTION from 'assets/images/facial/noImageForInspection.svg';

// Registration Validation
import NO_DOCUMENT_VALIDATION from 'assets/images/validation/noDocumentValidation.svg';
import IMAGE_100 from 'assets/images/facial/image100.svg';
import IMAGE_90 from 'assets/images/facial/image90.svg';
import IMAGE_80 from 'assets/images/facial/image80.svg';
import IMAGE_70 from 'assets/images/facial/image70.svg';
import IMAGE_60 from 'assets/images/facial/image60.svg';
import IMAGE_50 from 'assets/images/facial/image50.svg';
import IMAGE_40 from 'assets/images/facial/image40.svg';
import IMAGE_30 from 'assets/images/facial/image30.svg';
import IMAGE_20 from 'assets/images/facial/image20.svg';
import IMAGE_10 from 'assets/images/facial/image10.svg';

// Car Models
import STANDARD_CAR from 'assets/images/carModels/standard.svg';
import DOUBLE_DECK_CAR_01 from 'assets/images/carModels/double-deck-01.svg';
import DOUBLE_DECK_CAR_02 from 'assets/images/carModels/double-deck-02.svg';

// Company Management
import PIX from 'assets/images/icons/company_managment_icons/pix.svg';
import BOLETO from 'assets/images/icons/company_managment_icons/boleto.svg';
import BB_LOGO from 'assets/images/icons/company_managment_icons/banco-do-brasil-logo.svg';
import BRADESCO_LOGO from 'assets/images/icons/company_managment_icons/bradesco-logo.svg';
import SANTANDER_LOGO from 'assets/images/icons/company_managment_icons/banco-santander-logo.svg';
import SICREDI_LOGO from 'assets/images/icons/company_managment_icons/sicredi-branco-logo.svg';
import CAIXA_LOGO from 'assets/images/icons/company_managment_icons/caixa-logo.svg';
import CIELO_LOGO from 'assets/images/icons/company_managment_icons/cielo-logo.svg';
import FISERV_LOGO from 'assets/images/icons/company_managment_icons/fiserv-logo.svg';
import ADYEN_LOGO from 'assets/images/icons/company_managment_icons/adyen-logo.svg';
import BRADESCO_LOGO_SVG from 'assets/images/icons/company_managment_icons/bradescoicon.svg';
import VISA_LOGO from 'assets/images/icons/company_managment_icons/visa-logo.svg';

// Flags
import VISA_FLAG from 'assets/images/flags/visa.svg';
import MASTER_CARD_FLAG from 'assets/images/flags/master-card.svg';
import ELO_FLAG from 'assets/images/flags/elo.svg';
import DISCOVER_FLAG from 'assets/images/flags/discover.png';

// Logos
import LOGO4 from 'assets/images/logos/logo-onboard-04.png';
import LOGO_BDOS_01 from 'assets/images/logos/logo-onboard-bdos-01.png';
import LOGO_ONBOARD_MOBILITY from 'assets/images/logos/onboardMobilitylogo.png';
import LOGO_ONBOARD_MOBILITY_BLACK from 'assets/images/logos/new_logo_black_horizontal.png';
import LOGO_ONBOARD_MOBILITY_SMALL from 'assets/images/logos/onboardMobilitylogoSmall.png';
import LOGO_ONBOARD_MOBILITY_HORIZONTAL from 'assets/images/logos/Logo Onboard Horizontal.png';
import NEW_LOGO_ONBOARD_MOBILITY_HORIZONTAL from 'assets/images/logos/Logotipo Horizontal.svg';
import TEXT_WHITE_LOGO_ONBOARD_MOBILITY_HORIZONTAL from 'assets/images/logos/New Logotipo Horizontal.png';
import ONBOARD_LOGO_BLACK_HORIZONTAL from 'assets/images/logos/ONBOARD_LOGO_BLACK_HORIZONTAL.svg';
import AUTHENTICATOR_LOGO from 'assets/images/logos/authenticator-logo.svg';
import AUTHENTICATON_SUCCESS from 'assets/images/logos/authentication-success-logo.svg';

// Placeholders
import COMPANY_PLACEHOLDER from 'assets/images/placeholders/company.svg';
import INSTITUTION_PLACEHOLDER from 'assets/images/placeholders/institution.svg';
import HIDDEN_TABLE_PLACEHOLDER from 'assets/images/placeholders/hidden-table.svg';
import EDIT_COMPANY_PLACEHOLDER from 'assets/images/placeholders/editCompanyPlaceholder.svg';
import HER_PLACEHOLDER from 'assets/images/placeholders/her.png';
import PROFILES_PLACEHOLDER from 'assets/images/placeholders/profiles.png';
import BENEFITS_PLACEHOLDER from 'assets/images/placeholders/benefits.png';
import GENERIC_PLACEHOLDER from 'assets/images/placeholders/generic_placeholder.png';
import FARES_PLACEHOLDER from 'assets/images/placeholders/fares.png';
import DBD_PLACEHOLDER from 'assets/images/placeholders/dbd_placeholder.png';
import PLACEHOLDER_HER from 'assets/images/placeholders/placeholder_her.png';
import CAR_PLACEHOLDER from 'assets/images/placeholders/car_placeholder.png';
import KEY_PLACEHOLDER from 'assets/images/placeholders/key.svg';
import PERSON_PLACEHOLDER from 'assets/images/placeholders/person.svg';
import MAIL_BOX_PLACEHOLDER from 'assets/images/placeholders/email-box.svg';
import CARD_SUCCESS_ICON from 'assets/images/placeholders/card-success.svg';
import CARD_DEVICE_BLOCKED_ICON from 'assets/images/placeholders/card-device-blocked.svg';
import CARD_ERROR_ICON from 'assets/images/placeholders/card-error.svg';
import CONSULT_IMAGE_ICON from 'assets/images/placeholders/consultImage.svg';
import DELETE_PLACEHOLDER_IMAGE from 'assets/images/placeholders/delete_placeholder.svg';
import GENERIC_TERMINAL from 'assets/images/placeholders/generic-terminal.svg';
import SEND from 'assets/images/placeholders/send.svg';

// Backgrounds
import TICKET_SENT from 'assets/images/backgrounds/ticket_sent.svg';
import TICKET_SENT_CATSUL from 'assets/images/backgrounds/ticket_sent_catsul.svg';
import CHAT_BACKGROUND_IMAGE from 'assets/images/backgrounds/chatBackground.png';
import BLUE_BUBBLE_BG from 'assets/images/backgrounds/blue_bubble_bg.png';
import IMAGE_PASSENGER_NOT_FOUND from 'assets/images/backgrounds/image_passenger_not_found.jpg';
import IMAGE_GENERIC_ERROR from 'assets/images/backgrounds/generic_error.svg';

import ORANGE_BUBBLE_BG from 'assets/images/backgrounds/orange_bubble_bg.png';
import CREATE_WORKSPACE_BG from 'assets/images/backgrounds/create_workspace.png';
import WORKSPACE_PLACEHOLDER_BG from 'assets/images/backgrounds/workspace_bg.png';
import REQUEST_INVITE_BG from 'assets/images/backgrounds/request_invite.png';
import CREATE_CONSORTIUM from 'assets/images/backgrounds/criar-consorcio.png';
import TEAM_WORK_AMICO_CONSORTIUM from 'assets/images/backgrounds/team-work-amico-consorcio.png';
import PAGE_404 from 'assets/images/backgrounds/page404.png';
import PAGE_403 from 'assets/images/backgrounds/page403.png';
import PAGE_FEATURE_DISABLED from 'assets/images/backgrounds/page_feature_disabled.png';
import CONECTIVITY_DATA_PLAN from 'assets/images/backgrounds/conectivity.svg';
import ATTENDANCE_DATA_PLAN from 'assets/images/backgrounds/attendance_plan.svg';
import GENERIC_IMAGE from 'assets/images/backgrounds/genericImage.svg';
import UNAVAILABLE from 'assets/images/backgrounds/unavailable.svg';
import HEADER_ERROR from 'assets/images/backgrounds/header_error.svg';

import IMAGE_BACKGROUND0 from 'assets/images/backgrounds/background0.png';
import IMAGE_BACKGROUND1 from 'assets/images/backgrounds/background1.png';
import IMAGE_BACKGROUND2 from 'assets/images/backgrounds/background2.png';
import IMAGE_BACKGROUND3 from 'assets/images/backgrounds/background3.png';

import CONTRACT_BACKGROUND from 'assets/images/backgrounds/contract.png';
import COMPUTER from 'assets/images/computer.png';

import CONTRACT_HEADER from 'assets/images/backgrounds/contractHeader.png';
import CONTRACT_FOOTER from 'assets/images/backgrounds/contractFooter.png';

import VESSELS_ILUSTRATION_LARGE from 'assets/images/backgrounds/vessels_ilustration_large.jpg';
import REDENCAO_ILUSTRATION_LARGE from 'assets/images/backgrounds/redencao_ilustration_large.jpg';
import VESSELS_ILUSTRATION_EXTRA_LARGE from 'assets/images/backgrounds/vessels_ilustration_extra_large.jpg';
import VESSELS_CLOSED_SALE from 'assets/images/backgrounds/vessels_closed_sales.svg';
import VESSELS_CLOSED_SALE_OCEAN from 'assets/images/backgrounds/vessels_closed_sales_ocean.svg';
import VESSELS_CLOSED_SALE_VESSEL from 'assets/images/backgrounds/vessels_closed_sales_vessel.svg';
import REDENCAO_ILUSTRATION_LARGE_TWO from 'assets/images/backgrounds/redencao_ilustration_large_2.jpg';
import HORIZONTAL_BUS_PLAN from 'assets/images/backgrounds/horizontalBusPlan.svg';
import VERTICAL_BUS_PLAN from 'assets/images/backgrounds/verticalBusPlan.svg';

import IMAGE_BACKGROUND_CATSUL from 'assets/images/backgrounds/Banner_Catsul_trajeto_2400x1800.jpg';

// Others
import UNDER_CONSTRUCTION from 'assets/images/under-construction.png';
import REGISTER_PLANE from 'assets/images/register-plane.png';
import COMPANY_SKELETON from 'assets/images/companySkeleton.png';
import CONSORTIUM_SKELETON from 'assets/images/consorcioSkeleton.png';
import DEFAULT_COMPANY_IMAGE from 'assets/images/defaultCompanyImage.png';
import BOX_BUS_IMAGE from 'assets/images/boxBus.png';
import CSV_CHECK from 'assets/images/icons/csvCheck.png';
import PAPER_ICON from 'assets/images/paperIcon.png';
import STUDENT_DELETE_ICON from 'assets/images/studentDelete.svg';
import LYING_TRIANGLE from 'assets/images/lyingTriangle.png';
import CHECKED_RADIO_INPUT from 'assets/images/chekedRadionInput.svg';
import MANAGEMENT_WHITE from 'assets/images/modulesIconsWite/Gerenciar Empresa (Real Size).svg';
import NEW_ADD from 'assets/images/icons/newAdd.svg';
import ACESS from 'assets/images/icons/acess.svg';
import EMPTY_STAR from 'assets/images/icons/emptyStar.svg';
import FILLED_STAR from 'assets/images/icons/filledStar.svg';
import SCHOOL_DELETE_ICON from 'assets/images/schoolDelete.svg';
import PROFILE_CREATE_ICON from 'assets/images/successProfileCreate.svg';
import PROFILE_BLOCK_ICON from 'assets/images/blockProfile.svg';
import BEST_OPTION_STAMP from 'assets/images/selo_melhor_opcao.png';
import SUCCESS_CREATE_CONSORTIUM from 'assets/images/celebration-empresa-criada.png';
import IMAGE_NOT_FOUND from 'assets/images/placeholders/imageNotFound.svg';

// Tools Interface
import HOME from 'assets/images/icons/tools_interface/Homepage.svg';
import ANSWERS from 'assets/images/icons/tools_interface/Resposta.svg';

// User Social
import USER from 'assets/images/icons/user_social/Usuário.svg';

// Document File
import DOLA_FILE from 'assets/images/icons/document_file/Arquivo de Pedidos.svg';
import DOCUMENT from 'assets/images/icons/document_file/Documento.svg';
import CHECKED_FILE from 'assets/images/icons/document_file/Arquivo_de_Pedidos.svg';
import DOWN_FILE from 'assets/images/icons/document_file/Dar_Baixa_de_Arquivo.svg';

// Arrows
import AROW_UP from 'assets/images/icons/arrows/Arrow 2 Up.svg';
import AROW_DOWN from 'assets/images/icons/arrows/Arrow 2 Down.svg';
import REFRESH from 'assets/images/icons/arrows/Atualizar.svg';

// Shopping Payment Finance
import METODE_PIX from 'assets/images/icons/shopping_payments_finance/pix.svg';
import CODE_OF_BAR from 'assets/images/icons/shopping_payments_finance/code_of_bar.svg';
import MONEY from 'assets/images/icons/shopping_payments_finance/Dinheiro.svg';

// Location and Transport
import BUS from 'assets/images/icons/location_transport/Ônibus.svg';
import BUS_FILL from 'assets/images/icons/location_transport/Ônibus Fill.svg';

// Tools Interface
import TABLE from 'assets/images/icons/toos_interface/Tabela.svg';

// Tools Interface
import DISABLED_VESSEL from 'assets/images/illustration/disabled_vessel.png';
import VESSEL from 'assets/images/illustration/vessel.png';
import DISABLED_BUS_REDENCAO from 'assets/images/illustration/disabled_bus_redencao.jpg';
import BUS_REDENCAO from 'assets/images/illustration/bus_redencao.jpg';
import VOID_BACKGROUND from 'assets/images/illustration/voidBackground.png';
import NO_PENDENCIES_ILLUSTRATION from 'assets/images/illustration/nodebits.svg';
import IMAGE_CARDS_CATSUL from 'assets/images/illustration/Banner_Catsul_menor_500x400.jpg';
import IMAGE_CARDS_CATSUL_DISABLED from 'assets/images/illustration/Banner_Catsul_menor_500x400_Disabled.jpg';
import BUS_REDENCAO_TWO from 'assets/images/illustration/bus_redencao_2.png';
import DISABLED_BUS_REDENCAO_TWO from 'assets/images/illustration/disabled_bus_redencao_2.png';

// Illustration
import ITS_LOGO from 'assets/images/illustrationCompany.svg';
import ITS_LOGO_DISABLED from 'assets/images/illustrationCompanyDisabled.svg';
import REDENCAO_LOGO from 'assets/images/illustrationCompanyRedencao.svg';
import REDENCAO_LOGO_DISABLED from 'assets/images/illustrationCompanyDisabledRedencao.svg';
import CATSUL_LOGO from 'assets/images/illustrationCompanyCatsul.png';
import CATSUL_LOGO_DISABLED from 'assets/images/illustrationCompanyCatsulDisabled.png';
import REDENCAO_LOGO_TWO from 'assets/images/illustrationCompanyRedencao_2.png';
import REDENCAO_LOGO_GREEN from 'assets/images/illustrationCompanyRedencao_green.png';
import REDENCAO_LOGO_DISABLED_TWO from 'assets/images/illustrationCompanyDisabledRedencao_2.png';

export default {
  LOGOS: {
    LOGO4,
    LOGO_BDOS_01,
    LOGO_ONBOARD_MOBILITY,
    LOGO_ONBOARD_MOBILITY_BLACK,
    LOGO_ONBOARD_MOBILITY_SMALL,
    LOGO_ONBOARD_MOBILITY_SMALL_WHITE,
    LOGO_ONBOARD_MOBILITY_HORIZONTAL,
    NEW_LOGO_ONBOARD_MOBILITY_HORIZONTAL,
    TEXT_WHITE_LOGO_ONBOARD_MOBILITY_HORIZONTAL,
    ONBOARD_LOGO_BLACK_HORIZONTAL,
    AUTHENTICATOR_LOGO,
    AUTHENTICATON_SUCCESS,
  },
  UNDER_CONSTRUCTION,
  REGISTER: {
    PLANE: REGISTER_PLANE,
  },
  COMPANY_SKELETON,
  SUCCESS_CREATE_CONSORTIUM,
  CONSORTIUM_SKELETON,
  DEFAULT_COMPANY_IMAGE,
  COLOR_PICKER_IMAGE,
  BOX_BUS: BOX_BUS_IMAGE,
  COMPUTER,
  CSV_CHECK,
  PAPER_ICON,
  BEST_OPTION_STAMP,
  ICONS: {
    MAN_CHECKED: MAN_CHECKED_ICON,
    MAN_NO_CHECKED: MAN_NO_CHECKED_ICON,
    BUS_FRONT_CHECKED: BUS_FRONT_CHECKED_ICON,
    BUS_FRONT_NO_CHECKED: BUS_FRONT_NO_CHECKED_ICON,
    WHITE_PENCIL: ICON_WHITE_PENCIL,
    BLACK_PENCIL: ICON_BLACK_PENCIL,
    PERSON: PERSON_ICON,
    ADD: ADD_ICON,
    ATTENDANCE: ATTENDANCE_ICON,
    ATTENDANCE_CHATBOT: ATTENDANCE_CHATBOT_ICON,
    PLANNING: PLANNING_ICON,
    TABLE: TABLE_ICON,
    PLANNING2: PLANNING2_ICON,
    FLEET: FLEET_ICON,
    OPERATION: OPERATION_ICON,
    FARES: FARES_ICON,
    TICKETING: TICKETING_ICON,
    BIOMETRY: BIOMETRY_ICON,
    ADJUSTMENT: ADJUSTMENT_ICON,
    FINANCIAL: FINANCIAL_ICON,
    REPORTS: REPORTS_ICON,
    COLLECTION: COLLECTION_ICON,
    MONITORING: MONITORING_ICON,
    INTEGRITY_CENTER: INTEGRITY_CENTER_ICON,
    TEAM: TEAM_ICON,
    CHECK: CHECK_ICON,
    CHECK_OUTLINE: CHECK_OUTLINE_ICON,
    CHECK_CIRCLE_OUTLINE: CHECK_CIRCLE_OUTLINE_ICON,
    APROVE: APROVE_ICON,
    REPROVE: REPROVE_ICON,
    IMPRECISION: IMPRECISION_ICON,
    BACK_BUTTON: BACK_BUTTON_ICON,
    NEXT_BUTTON: NEXT_BUTTON_ICON,
    REPROVE_LARGE: REPROVE_LARGE_ICON,
    CAMERA: CAMERA_ICON,
    IMAGE_OBSTRUCTION: IMAGE_OBSTRUCTION_ICON,
    SLOW_RESOLUTION: SLOW_RESOLUTION_ICON,
    LOW_LIGHT: LOW_LIGHT_ICON,
    EXCESS_BRIGHTNESS: EXCESS_BRIGHTNESS_ICON,
    ANOTHER_MOTIVE: ANOTHER_MOTIVE_ICON,
    EYE_ON: EYE_ON_ICON,
    EYE_OFF: EYE_OFF_ICON,
    PHONE: PHONE_ICON,
    SMARTCARD: CARD_ICON,
    CREDIT_CARD: CARD_ICON,
    DEBIT_CARD: DEBIT_CARD_ICON,
    WEREABLE: SMARTWATCH_ICON,
    CHECKED: CHECK_ICON,
    UNCHECKED: UNCHECKED_ICON,
    BLOCK: BLOCK_ICON,
    SAVE: SAVE_ICON,
    EDIT: EDIT_ICON,
    DELETE: DELETE_ICON,
    UPDATE: UPDATE_ICON,
    CLOSE: CLOSE_ICON,
    MORE_HORIZ: MORE_HORIZ_ICON,
    ARROW_FORWARD: ARROW_FORWARD_ICON,
    ARROW_BACK: ARROW_BACK_ICON,
    BALLON: BALLON_ICON,
    BALLON_HIGH: BALLON_HIGH_ICON,
    BALLON_MEDIUM: BALLON_MEDIUM_ICON,
    BALLON_SLOW: BALLON_SLOW_ICON,
    DESTROY: DESTROY_ICON,
    FAILURE: FAILURE_ICON,
    CHART: CHART_ICON,
    NON_STANDARD: NON_STANDARD_ICON,
    INVALID_DOCUMENT: INVALID_DOCUMENT_ICON,
    INCOMPATIBLE_PHOTO: INCOMPATIBLE_PHOTO_ICON,
    NOTATION: NOTATION_ICON,
    CALENDAR: CALENDAR_ICON,
    CALENDAR_BLACK: CALENDAR_ICON_BLACK,
    CALENDAR_BLUE: CALENDAR_ICON_BLUE,
    HISTORY_BLUE: HISTORY_ICON_BLUE,
    PROGRAMMING_BLUE: PROGRAMMING_ICON_BLUE,
    CALENDAR_OUTLINE: CALENDAR_OUTLINE_ICON,
    HISTORY: HISTORY_ICON,
    XLSX: XLSX_ICON,
    NO_IMAGE: NO_IMAGE_ICON,
    CSV: CSV_ICON,
    CSV2: CSV2_ICON,
    PDF: PDF_ICON,
    DOWNLOAD: DOWNLOAD_ICON,
    EMPLOYEE: EMPLOYEE_ICON,
    CAR: CAR_ICON,
    ATTACHMENT: ATTACHMENT_ICON,
    OPEN_EYES,
    CLOSE_EYES,
    BUS: BUS_ICON,
    LINE: LINE_ICON,
    STOP: STOP_ICON,
    CART: CART_ICON,
    WATCH: WATCH_ICON,
    CONECTIVITY: CONECTIVITY_ICON,
    EMAIL_ICON,
    FILTORS: FILTORS_BUTTON,
    SAVE_COMPANY: SAVE_COMPANY_ICON,
    CLOSE_COMPANY: CLOSE_COMPANY_ICON,
    EDIT_COMPANY: EDIT_COMPANY_ICON,
    DELETE_COMPANY: DELETE_COMPANY_ICON,
    CAMERA_COMPANY: CAMERA_COMPANY_ICON,
    SEND: SEND_ICON,
    PAINT: PAINT_ICON,
    SEND_DISABLED: SEND_DISABLED_ICON,
    CHANGED_ROW: CHANGED_ROW_ICON,
    INFO: INFO_ICON,
    IMAGE: IMAGE_ICON,
    DOWN_ARROW,
    UP_ARROW,
    OK,
    MINI_CAMERA: MINI_CAMERA_ICON,
    UPLOAD: UPLOAD_ICON,
    LUPA,
    FILLED_STAR,
    EMPTY_STAR,
    ACESS,
    NEW_ADD,
    OPEN_DOT: OPEN_DOT_ICON,
    CLOSE_DOT: CLOSE_DOT_ICON,
    DOCUMENT: DOCUMENT_ICON,
    BOOK: BOOK_ICON,
    APPROVE_PROFILE: APPROVE_PROFILE_ICON,
    APPROVE_PROFILE_FLAT: APPROVE_PROFILE_ICON_FLAT,
    BLOCK_PROFILE: BLOCK_PROFILE_ICON,
    BLOCK_PROFILE_FLAT: BLOCK_PROFILE_ICON_FLAT,
    UPDATE_DENYLIST,
    DBD_ICON,
    MERGE_ACCOUNTS: MERGE_ACCOUNTS_ICON,
    MERGE_ACCOUNTS_BLACK: MERGE_ACCOUNTS_ICON_BLACK,
    MERGE_ACCOUNTS_WARNING: MERGE_ACCOUNTS_WARNING_ICON,
    MERGE_ACCOUNTS_FIRST_CARD: MERGE_ACCOUNTS_FIRST_CARD_ICON,
    MERGE_ACCOUNTS_SECOND_CARD: MERGE_ACCOUNTS_SECOND_CARD_ICON,
    MERGE_ACCOUNTS_PLACEHOLDER: MERGE_ACCOUNTS_SECOND_CARD_PLACEHOLDER,
    MERGE_ACCOUNTS_SUCCESS: MERGE_ACCOUNTS_SUCCESS_PLACEHOLDER,
    MERGE_ACCOUNTS_ERROR: MERGE_ACCOUNTS_ERROR_PLACEHOLDER,
    CONFLICT_SCHEDULES_IMAGE: CONFLICT_SCHEDULES_IMAGE_PLACEHOLDER,
    CLOCK: CLOCK_ICON,
    GROUPINGS,
    FILE,
    ALERT,
    REPLY_TABLE: REPLY_TABLE_ICON,
    PIX: PIX_ICON,
    PIX_BLUE: PIX_ICON_BLUE,
    BOLETO: BOLETO_ICON,
    BOLETO_BLUE: BOLETO_ICON_BLUE,
    ONBOARD_LOGO: ONBOARD_LOGO_ICON,
    CHECK_ICON: CHECK_ICON_BLUE,
    TERMINAL_ICON_01: TERMINAL_ICON_01_ICON,
    TERMINAL_ICON_02: TERMINAL_ICON_02_ICON,
    TERMINAL_ICON_03: TERMINAL_ICON_03_ICON,
    TERMINAL_ICON_04: TERMINAL_ICON_04_ICON,
    TERMINAL_ICON_05: TERMINAL_ICON_05_ICON,
    TERMINAL_ICON_06: TERMINAL_ICON_06_ICON,
    TERMINAL_ICON_07: TERMINAL_ICON_07_ICON,
    TERMINAL_ICON_08: TERMINAL_ICON_08_ICON,
    TERMINAL_ICON_09: TERMINAL_ICON_09_ICON,
    TERMINAL_ICON_10: TERMINAL_ICON_10_ICON,
    TERMINAL_ICON_11: TERMINAL_ICON_11_ICON,
    TERMINAL_ICON_12: TERMINAL_ICON_12_ICON,
    TERMINAL_ICON_13: TERMINAL_ICON_13_ICON,
    TERMINAL_ICON_14: TERMINAL_ICON_14_ICON,
    LOCK_IDLE: LOCK_IDLE_ICON,
    EDIT_BLACK: EDIT_BLACK_ICON,
    ROTATE_BLACK: ROTATE_BLACK_ICON,
    DELETE_BLACK: DELETE_BLACK_ICON,
    ENTRY_BLOCK: ENTRY_BLOCK_ICON,
    BLOCK_HAS_ALERT: BLOCK_HAS_ALERT_ICON,
    EXIT_BLOCK: EXIT_BLOCK_ICON,
    FREE_BLOCK: FREE_BLOCK_ICON,
    LOCKED_BLOCK: LOCKED_BLOCK_ICON,
    ACTIVITY_LOG: ACTIVITY_LOG_ICON,
    TRANSACTIONS_RESUME: TRANSACTIONS_RESUME_ICON,
    UPDATE_STATUS_BUTTON: UPDATE_STATUS_BUTTON_ICON,
    RELEASE_BLOCKS: RELEASE_BLOCKS_ICON,
    RESET_BLOCKS: RESET_BLOCKS_ICON,
    RELEASE_BLOCKS_GREEN: RELEASE_BLOCKS_GREEN_ICON,
    RELEASE_BLOCKS_ORANGE: RELEASE_BLOCKS_ORANGE_ICON,
    NFE: NFE_ICON,
    LINK: LINK_ICON,
    INFO_2: INFO_ICON_2,
    CLOCK_2: CLOCK_ICON_2,
    PASSENGERS_BY_TERMINAL: PASSENGERS_BY_TERMINAL_ICON,
    VOUCHER_SRC: VOUCHER_SRC_ICON,
    IP_ADDRESS: IP_ADDRESS_ICON,
    MONEY_SRC: MONEY_SRC_ICON,
    DETAILS: DETAILS_ICON,
    PRINTER: PRINTER_ICON,
    REPLY_TABLE_DISABLED: REPLY_TABLE_ICON_DISABLED,
    SHOPPING_CART: SHOPPING_CART_ICON,
    SHOPPING_CART_BLUE: SHOPPING_CART_ICON_BLUE,
    SEND_FILE: SEND_FILE_ICON,
    FINISHED: FINISHED_ICON,
    PENDING: PENDING_ICON,
    FAILED: FAILED_ICON,
    TRIP_REPORT: TRIP_REPORT_ICON,
    TERMINAL_BLACK: TERMINAL_ICON_BLACK,
    NOT_TERMINAL_BLACK: NOT_TERMINAL_ICON_BLACK,
    ANOTATIONS,
    CURRENCY,
    LIKE,
    SALES_NETWORK,
    COMPANY_BENEFITS,
    COMPANY_COLLABORATORS,
  },
  PLACEHOLDER_IMAGES: {
    SEND,
    DBD: DBD_PLACEHOLDER,
    HER: PLACEHOLDER_HER,
    CAR: CAR_PLACEHOLDER,
    GENERIC: GENERIC_PLACEHOLDER,
    COMPANY: COMPANY_PLACEHOLDER,
    INSTITUTION: INSTITUTION_PLACEHOLDER,
    HIDDEN_TABLE: HIDDEN_TABLE_PLACEHOLDER,
    EDIT_COMPANY: EDIT_COMPANY_PLACEHOLDER,
    PROFILES: PROFILES_PLACEHOLDER,
    BENEFITS: BENEFITS_PLACEHOLDER,
    GENERIC_PLACEHOLDER,
    ASTRONAUT,
    RESET_PASSWORD,
    IVITE_MESSAGE_PASSWORD,
    CELEBRATION_PANA_SUCCES,
    FARES: FARES_PLACEHOLDER,
    KEY: KEY_PLACEHOLDER,
    PERSON: PERSON_PLACEHOLDER,
    MAIL_BOX: MAIL_BOX_PLACEHOLDER,
    CARD_SUCCESS: CARD_SUCCESS_ICON,
    CARD_DEVICE_BLOCKED: CARD_DEVICE_BLOCKED_ICON,
    CARD_ERROR: CARD_ERROR_ICON,
    CONSULT_IMAGE: CONSULT_IMAGE_ICON,
    DELETE_PLACEHOLDER: DELETE_PLACEHOLDER_IMAGE,
    GENERIC_TERMINAL,
  },
  BACKGROUND_IMAGES: {
    TICKET_SENT,
    BLUE_BUBBLE: BLUE_BUBBLE_BG,
    ORANGE_BUBBLE: ORANGE_BUBBLE_BG,
    HER: HER_PLACEHOLDER,
    CHAT_BACKGROUND: CHAT_BACKGROUND_IMAGE,
    CREATE_WORKSPACE: CREATE_WORKSPACE_BG,
    WORKSPACE_PLACEHOLDER: WORKSPACE_PLACEHOLDER_BG,
    REQUEST_INVITE: REQUEST_INVITE_BG,
    CREATE_CONSORTIUM,
    TEAM_WORK_AMICO_CONSORTIUM,
    PAGE_404,
    PAGE_403,
    PAGE_FEATURE_DISABLED,
    BACKGROUND0: IMAGE_BACKGROUND0,
    BACKGROUND1: IMAGE_BACKGROUND1,
    BACKGROUND2: IMAGE_BACKGROUND2,
    BACKGROUND3: IMAGE_BACKGROUND3,
    CONTRACT_BACKGROUND,
    CONTRACT_HEADER,
    CONTRACT_FOOTER,
    CONECTIVITY_DATA_PLAN,
    ATTENDANCE_DATA_PLAN,
    LYING_TRIANGLE,
    CHECKED: CHECKED_RADIO_INPUT,
    GENERIC_IMAGE,
    VESSELS_ILUSTRATION_LARGE,
    REDENCAO_ILUSTRATION_LARGE,
    REDENCAO_ILUSTRATION_LARGE_TWO,
    VESSELS_ILUSTRATION_EXTRA_LARGE,
    VESSELS_CLOSED_SALE,
    VESSELS_CLOSED_SALE_OCEAN,
    VESSELS_CLOSED_SALE_VESSEL,
    UNAVAILABLE,
    IMAGE_PASSENGER_NOT_FOUND,
    IMAGE_GENERIC_ERROR,
    HEADER_ERROR,
    IMAGE_NOT_FOUND,
    IMAGE_BACKGROUND_CATSUL,
    HORIZONTAL_BUS_PLAN,
    VERTICAL_BUS_PLAN,
  },
  CAR_MODELS: {
    STANDARD: STANDARD_CAR,
    DOUBLE_DECK_01: DOUBLE_DECK_CAR_01,
    DOUBLE_DECK_02: DOUBLE_DECK_CAR_02,
  },
  TRASH_IMAGE_URL: DELETE_ICON,
  LARGE_TRASH: LARGE_TRASH_ICON,
  STUDENT_DELETE: STUDENT_DELETE_ICON,
  SCHOOL_DELETE: SCHOOL_DELETE_ICON,
  PROFILE_CREATE: PROFILE_CREATE_ICON,
  PROFILE_BLOCK: PROFILE_BLOCK_ICON,
  VALIDATION: {
    NO_DOCUMENT_VALIDATION,
  },
  FACIAL: {
    NO_IMAGE_INSPECTION,
    IMAGE100: IMAGE_100,
    IMAGE90: IMAGE_90,
    IMAGE80: IMAGE_80,
    IMAGE70: IMAGE_70,
    IMAGE60: IMAGE_60,
    IMAGE50: IMAGE_50,
    IMAGE40: IMAGE_40,
    IMAGE30: IMAGE_30,
    IMAGE20: IMAGE_20,
    IMAGE10: IMAGE_10,
  },
  MAP_CONTROL_ICONS: {
    WIFI_ACTIVED,
    PURCHASE_ACTIVED,
    POLYGON_AGROUP,
    LINE_ACTIVED,
    POINT_ACTIVED,
    WIFI,
    PURCHASE,
    LINE,
    POINT,
    BOARDING,
    LANDING,
    GO_ARROW,
    BACK_ARROW,
    BOARDING_ACTIVED,
    LANDING_ACTIVED,
    GO_ARROW_ACTIVED,
    BACK_ARROW_ACTIVED,
    VIVO,
    CLARO,
    TIM,
    OI,
  },
  MODULES_ICON_BLACK: {
    ATTENDANCE_BLACK,
    CLIENTS_BLACK,
    VALIDATIONS_BLACK,
    RELATIONSHIP_BLACK,
    FLEET_BLACK,
    TEAM_BLACK,
    TICKETING_BLACK,
    OPERATION_BLACK,
    SCHEDULE_BLACK,
    OCCURRENCES_BLACK,
    MONITORING_BLACK,
    COLLECTION_BLACK,
    ANALYTICS_BLACK,
    REPORTS_BLACK,
    SETTINGS_BLACK,
    INVOICES_BLACK,
    MANAGEMENT_BLACK,
    CONECTIVITY_BLACK,
  },
  MODULES_ICON_WHITE: {
    ATTENDANCE_WHITE,
    CLIENTS_WHITE,
    VALIDATIONS_WHITE,
    RELATIONSHIP_WHITE,
    FLEET_WHITE,
    TEAM_WHITE,
    TICKETING_WHITE,
    OPERATION_WHITE,
    SCHEDULE_WHITE,
    OCCURRENCES_WHITE,
    MONITORING_WHITE,
    COLLECTION_WHITE,
    ANALYTICS_WHITE,
    REPORTS_WHITE,
    SETTINGS_WHITE,
    INVOICES_WHITE,
    MANAGEMENT_WHITE,
    CONECTIVITY_WHITE,
  },
  REPORTS_ICONS: {
    TOTAL_ENTRY,
    QUANTITY_ENTRY,
    DOWNLOAD,
    TICKET_SOLD,
    CREDIT_PORTFOLIO,
    PDF,
    CSV,
    XLS,
    PDF_CHECKED,
    CSV_CHECKED,
    XLS_CHECKED,
    FILTERS,
    AGRUPMENTS,
    AGRUPMENTS_BLACK,
    OPEN_REPORTS,
    SEND_MENSSAGE,
    FILTERS_BLACK,
  },
  FLAG: {
    VISA_FLAG,
    MASTER_CARD_FLAG,
    ELO_FLAG,
    DISCOVER_FLAG,
  },
  COMPANY_MANAGMENT_ICONS: {
    PIX,
    BOLETO,
    BB_LOGO,
    BRADESCO_LOGO,
    SANTANDER_LOGO,
    SICREDI_LOGO,
    CAIXA_LOGO,
    CIELO_LOGO,
    FISERV_LOGO,
    ADYEN_LOGO,
    BRADESCO_LOGO_SVG,
    VISA_LOGO,
  },
  TOOLS_INTERFACE: {
    HOME,
    ANSWERS,
  },
  USER_SOCIAL: {
    USER,
  },
  DOCUMENT_FILE: {
    DOLA_FILE,
    DOCUMENT,
    CHECKED_FILE,
    DOWN_FILE,
  },
  ARROWS: {
    AROW_UP,
    AROW_DOWN,
  },
  SHOPPING_PAYMENT_FINANCE: {
    PIX: METODE_PIX,
    CODE_OF_BAR,
    MONEY,
  },
  LOCATION_TRANSPORT: {
    BUS,
    BUS_FILL,
    REFRESH,
  },
  TOOS_INTERFACE: {
    TABLE,
  },
  ILLUSTRATION: {
    VESSEL,
    DISABLED_VESSEL,
    BUS_REDENCAO,
    BUS_REDENCAO_TWO,
    DISABLED_BUS_REDENCAO,
    DISABLED_BUS_REDENCAO_TWO,
    VOID_BACKGROUND,
    ITS_LOGO,
    ITS_LOGO_DISABLED,
    REDENCAO_LOGO,
    REDENCAO_LOGO_TWO,
    REDENCAO_LOGO_GREEN,
    REDENCAO_LOGO_DISABLED,
    REDENCAO_LOGO_DISABLED_TWO,
    IMAGE_CARDS_CATSUL,
    IMAGE_CARDS_CATSUL_DISABLED,
    CATSUL_LOGO,
    CATSUL_LOGO_DISABLED,
    TICKET_SENT,
    TICKET_SENT_CATSUL,
    NO_PENDENCIES_ILLUSTRATION,
  },
};
